import { useDispatch } from 'react-redux';
import useTF911LoggedInUser from '@rsos/hooks/talkjs/useTF911LoggedInUser';
import { useTalkJS } from '@rsos/utils/useTalkJS';
import useTalkJSTheme from '../../hooks/useTalkJSTheme';
import {
  useSelectedInteragencyChat,
  usePendingInteragencyMessage,
  setPendingInteragencyMessage,
} from '../../reduxDataStore/interagency/interagencySlice';
import styles from './InteragencyChat.module.css';

const INSTANCE_ID = 'interagency';

const InteragencyChat = () => {
  const chatTheme = useTalkJSTheme('interagency');
  const loggedInUser = useTF911LoggedInUser();
  const selectedConversation = useSelectedInteragencyChat();
  const pendingMessage = usePendingInteragencyMessage();
  const dispatch = useDispatch();

  const { shellRef } = useTalkJS({
    theme: chatTheme,
    user: loggedInUser,
    instanceID: INSTANCE_ID,
    conversationId: selectedConversation,
    pendingMessage,
    onMessageSent: () => {
      dispatch(setPendingInteragencyMessage(null));
    },
  });

  return <div ref={shellRef} className={styles.chatShell} />;
};

export default InteragencyChat;
